<template>
  <div class="item">
    <div class="item-head">
      <div class="item-head_name">
        <span v-if="product.doc_type" class="tag">Produit</span>
        <status-chip :status="product.status"></status-chip>
        <router-link
          v-if="authenticated && hasActiveSubscription"
          :to="{ name: routeNameToDetail, params: { id: String(product.id) } }"
        >
          {{ product.name }}
        </router-link>
        <div v-else>{{ product.name }}</div>
        <div
          class="flex gap-2 ml-2"
          :class="{ 'alert-bell': favorite && item.alert }"
        >
          <div v-if="product.logo_biocontrole" class="has-tooltip">
            <img
              src="@/assets/images/coccifeuille.png"
              alt="Logo Biocontrôle"
              style="object-fit: contain; width: 22px;"
            />
            <span class="tooltip">PPP de biocontrôle (liste ministère)</span>
          </div>
          <div v-if="product.logo_ab_use" class="has-tooltip">
            <img
              src="@/assets/images/picto-UAB.png"
              alt="Logo Agriculture Biologique"
              style="object-fit: contain; width: 30px;"
            />
            <span class="tooltip">Utilisable en agriculture biologique</span>
          </div>
          <div v-if="product.gamme_amateur" class="has-tooltip">
            <img
              width="40"
              src="@/assets/images/brouette-01_fond-transparent.png"
              alt="Utilisable par les amateurs / EAJ"
            />
            <span class="tooltip">Utilisable par les amateurs / EAJ</span>
          </div>
        </div>
      </div>
      <span v-if="authenticated && hasActiveSubscription" class="item-head_fav">
        <button
          v-if="favoriteProducts.includes(castedId)"
          @click="removeFavorite('products', castedId)"
          class="btn-fav btn-fav--faved"
        ></button>
        <button
          v-else
          @click="addFavorite('products', castedId)"
          class="btn-fav btn-fav"
        ></button>
      </span>
    </div>

    <div
      class="format-produit item-content"
      v-show="product.type"
      :class="authenticated && hasActiveSubscription ? '' : 'blur'"
    >
      <div class="item-type">
        <span class="item-label">Type :</span>
        <span class="item-text">
          {{ product.type | capitalize }}
        </span>
      </div>
      <div class="item-fonction" v-show="product.natures.length">
        <span class="item-label">Fonction :</span>
        <span class="item-text">
          <span>
            {{ getProductInfos(product, "natures", ", ") }}
          </span>
        </span>
      </div>
      <div class="item-class" v-show="product.classifications.length">
        <span class="item-label">Classification :</span>
        <span class="item-text">
          <span>
            {{ getProductInfosSorted(product, "classifications", " - ") }}
          </span>
        </span>
      </div>
      <div class="item-amm" v-show="product.amm">
        <span class="item-label">Numéro AMM :</span>
        <span class="item-text"> {{ product.amm }}</span>
      </div>
      <div class="item-firme" v-show="product.firm">
        <span class="item-label">Firme :</span>
        <span class="item-text"> {{ product.firm }}</span>
      </div>
      <div class="item-firm-logo" v-if="product.firm_data.logo" >
        <span  class="item-label">
        <a :href="product.firm_data.url" target="_blank">
            <img
            class="w-auto h-24 object-contain" 
            :src="`/media/${product.firm_data.logo}`"
            :alt="product.firm_data.name"
          />
          </a>
        </span>
      </div>
      <div
        class="item-composition"
        v-show="product.productactivesubstance_set.length"
      >
        <span class="item-label">Composition :</span>
        <span class="item-text">
          <span>
            {{ getProductComposition(product) }}
          </span>
        </span>
      </div>
      <div
        class="item-formulation" v-if="product.formulation"
      >
        <span class="item-label">Formulation :</span>
        <span class="item-text">
          <span>
            {{product.formulation.code}} ({{product.formulation.name}})
          </span>
        </span>
      </div>
      <div
        class="item-culture"
        v-if="product.cultivations && product.cultivations.length"
      >
        <span class="item-label">Cultures : </span>
        <span class="item-text">
          <span>[...]</span>
          <span v-html="getProductInfos(product, 'cultivations', ', ')"></span>
          <span> [...]</span>
        </span>
      </div>
      <div class="item-cible" v-if="product.targets && product.targets.length">
        <span class="item-label">Cibles : </span>
        <span class="item-text">
          <span>[...]</span>
          <span v-html="getProductInfos(product, 'targets', ', ')"></span>
          <span> [...]</span>
        </span>
      </div>
    </div>
    <div v-if="favorite" class="last-update">
      Données au :
      {{ product.last_phytcom_update }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StatusChip from "@/components/StatusChip";
import FavoriteMixin from "@/mixins/FavoriteMixin.js";
import moment from "moment";

export default {
  name: "ProductsListingRow",
  components: { StatusChip },
  mixins: [FavoriteMixin],

  props: {
    item: Object,
    routeNameToDetail: {
      type: String,
      default: "productIdentity",
    },
    favorite: Boolean,
  },

  computed: {
    ...mapState("authent", {
      favoriteProducts: (state) => state.user?.favorite_products || [],
    }),
    product() {
      return this.favorite ? this.item.product : this.item;
    },
    castedId() {
      return Number(this.product.id);
    },
    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },
    hasActiveSubscription() {
      return this.$store.getters["authent/hasActiveSubscription"];
    },
  },

  methods: {
    getProductInfos(product, type, separator) {
      return this.product[type].join(separator);
    },
    getProductInfosSorted(product, type, separator) {
      let temp = [...this.product[type]];
      return temp.sort((a, b) => a.localeCompare(b)).join(separator);
    },
    getProductComposition(product) {
      return product.productactivesubstance_set
        .map((item) => {
          return (
            item.active_substance.name +
            item.active_substance.code_rac
              .map((rac) => {
                return " (" + rac.rac_type + " : " + rac.code + ")";
              })
              .join(", ") +
            (item.concentration
              ? " - " + item.concentration.toString().replace(".", ",")
              : "") +
            (item.unit ? item.unit : "")
          );
        })
        .join(" ; ");
    },

    hasBeenUpdated() {
      return moment(this.product.last_update, "DD/MM/YYYY").isBefore(
        this.item?.last_seen
      );
    },

    format_date(date) {
      moment().locale("fr");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
